const destinations = [
  {
    region: "Caribbean",
    cities: "Nassau, Cozumel, Grand Cayman, Jamaica",
    travelTime: "Direct flights from PIE or TPA: 1.5–3 hrs",
    frequency: "Most Common",
    context: "Cruises from Port Tampa Bay and quick island getaways booked from St. Pete Beach, Treasure Island, and Pass-a-Grille. The Caribbean is the top choice for Pinellas County beach-town travelers.",
    popularWith: ["Cruise passengers", "Spring breakers", "Beach lovers"],
    icon: "ri-sun-cloudy-line",
  },
  {
    region: "Mexico",
    cities: "Cancun, Cabo San Lucas, Puerto Vallarta, Playa del Carmen",
    travelTime: "Direct flights from TPA: 2–3 hrs",
    frequency: "Very Common",
    context: "Mexico is a favorite for St. Petersburg spring breakers and winter escapees. Affordable all-inclusive resorts and warm beaches make it a year-round draw for Pinellas County residents.",
    popularWith: ["Spring break families", "Winter escapees", "Budget travelers"],
    icon: "ri-tree-line",
  },
  {
    region: "Europe",
    cities: "Paris, London, Rome, Barcelona, Amsterdam",
    travelTime: "Connecting flights from TPA: 8–12 hrs",
    frequency: "Common",
    context: "St. Petersburg's art scene (anchored by the Dali Museum) inspires many locals to visit European galleries, museums, and historic cities. Summer is peak season for European art and cultural tourism.",
    popularWith: ["Art enthusiasts", "Cultural tourists", "Summer vacationers"],
    icon: "ri-building-line",
  },
  {
    region: "Canada",
    cities: "Toronto, Vancouver, Montreal, Calgary",
    travelTime: "Direct flights from TPA: 3–4 hrs",
    frequency: "Common",
    context: "Rays fans follow the team to Toronto, and many St. Petersburg residents visit Canadian cities for business, family visits, and summer getaways. A passport book is required for all air travel to Canada.",
    popularWith: ["Baseball fans", "Business travelers", "Family visitors"],
    icon: "ri-building-2-line",
  },
  {
    region: "Latin America",
    cities: "Costa Rica, Belize, Panama, Colombia",
    travelTime: "Direct flights from TPA: 3–5 hrs",
    frequency: "Growing",
    context: "Eco-tourism and adventure travel are trending among St. Petersburg residents. Rainforest hikes, scuba diving, and cultural immersion in Central and South America attract Pinellas County travelers year-round.",
    popularWith: ["Eco-tourists", "Adventure travelers", "Retirees"],
    icon: "ri-leaf-line",
  },
  {
    region: "Asia & South Pacific",
    cities: "Tokyo, Bangkok, Sydney, Bali",
    travelTime: "Connecting flights from TPA: 14–20 hrs",
    frequency: "Less Common",
    context: "Long-haul destinations for St. Petersburg's most adventurous travelers. These trips require significant planning and a valid passport with at least 6 months validity.",
    popularWith: ["Adventure travelers", "Honeymooners", "Bucket-list travelers"],
    icon: "ri-plane-line",
  },
];

export default function StPetersburgDestinationsSection() {
  return (
    <section id="destinations" className="bg-[#F7F8FA] py-20 md:py-28">
      <div className="max-w-7xl mx-auto px-4 md:px-8">
        <div className="text-center mb-14">
          <p className="text-[#F6C344] text-xs font-bold uppercase tracking-[0.2em] mb-3">Popular Destinations</p>
          <h2 className="font-serif text-3xl md:text-4xl font-bold text-[#1A365D] mb-4">
            Where St. Petersburg Travelers Go Most
          </h2>
          <p className="text-gray-500 max-w-2xl mx-auto text-base leading-relaxed">
            From Caribbean cruises to European art tours and spring break in Mexico, here are the most popular international destinations for Pinellas County residents — and why a valid passport is essential for every trip.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-5">
          {destinations.map((dest, i) => (
            <div
              key={i}
              className="bg-white rounded-lg border border-gray-200 p-6 hover:border-[#F6C344] transition-all duration-300"
            >
              <div className="flex items-start gap-3 mb-4">
                <div className="w-10 h-10 flex items-center justify-center rounded-full bg-[#1A365D] flex-shrink-0">
                  <i className={`${dest.icon} text-[#F6C344] text-lg`}></i>
                </div>
                <div>
                  <h3 className="font-bold text-[#1A365D] text-sm leading-snug">{dest.region}</h3>
                  <span className="text-xs font-semibold text-[#F6C344]">{dest.frequency}</span>
                </div>
              </div>
              <p className="text-gray-500 text-xs leading-relaxed mb-3">
                <span className="text-gray-700 font-semibold">Top cities:</span> {dest.cities}
              </p>
              <p className="text-gray-400 text-xs mb-4">
                <i className="ri-flight-takeoff-line text-[#F6C344] mr-1"></i>
                {dest.travelTime}
              </p>
              <p className="text-gray-600 text-sm leading-relaxed mb-4">{dest.context}</p>
              <div className="flex flex-wrap gap-2">
                {dest.popularWith.map((tag, j) => (
                  <span
                    key={j}
                    className="text-xs font-medium bg-[#F7F8FA] text-[#1A365D] border border-gray-200 rounded-full px-2.5 py-1 whitespace-nowrap"
                  >
                    {tag}
                  </span>
                ))}
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}